export default function validate(values = { field: '', search: '' }, message = '') {
  const { field, search } = values;

  return {
    field: !field && 'Pilih Parameter',
    search: !search && 'Masukkan data' || message,
  };
}

export const messageMapping = {
  'registrationId': 'Pangkalan tidak ditemukan, pastikan ID Registrasi yang Anda masukkan benar',
  'midMap': 'Pangkalan tidak ditemukan, pastikan MID yang Anda masukkan benar',
  'phoneNumber': 'Pangkalan tidak ditemukan, pastikan No Handphone yang Anda masukkan benar',
  'email': 'Pangkalan tidak ditemukan, pastikan Email yang Anda masukkan benar',
};
